import React from 'react'
import { useParams, Outlet, useMatch } from 'react-router-dom'
import ClinicThemeShell from './ClinicThemeShell'

const ClinicLayout = () => {
  const { clinicId } = useParams()
  // Survey pageWidth comes from the API and must control layout width.
  // Disable the shell Container maxWidth so it does not cap/override it.
  const isSurveyPage = Boolean(
    useMatch('/clinics/:clinicId/surveys/:surveyId/patient/:patientId')
  )

  return (
    <ClinicThemeShell
      clinicId={clinicId}
      contentMaxWidth={isSurveyPage ? false : 'lg'}
    >
      {({ clinicContent, clinicName }) => (
        <Outlet context={{ clinicContent, clinicName }} />
      )}
    </ClinicThemeShell>
  )
}

export default ClinicLayout
